'use strict';

var $isNaN = require('../helpers/isNaN');

// https://262.ecma-international.org/6.0/#sec-samevaluezero

module.exports = function SameValueZero(x, y) {
	return (x === y) || ($isNaN(x) && $isNaN(y));
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2022/SameValueZero.js
// module id = 1093
// module chunks = 0